import React from 'react';
import { isNull } from 'lodash/fp';

import { Toggle } from '../../../shared/toggle';
import { QuestionsAndAnswers } from './store';
import styles from './AIPlayground.module.scss';
import { InformationTooltip } from '../../../shared/tooltip';

export interface AIPreviousQuestionsAndAnswersProps {
    query: QuestionsAndAnswers;
    toggleQuestion: (question: QuestionsAndAnswers) => void;
    checked: boolean;
}

export const AIPreviousQuestionsAndAnswers: React.FC<AIPreviousQuestionsAndAnswersProps> = ({ query, toggleQuestion, checked }) => {
    const { question, answer } = query;
    const answerValue = isNull(answer.value) ? 'Not found' : answer.value as string;
    return (
        <div key={query.queryKey} className={styles.previouslyAskedQueryAndToggleWrapper}>
            <div className={styles.previouslyAskedQueryWrapper} key={query.queryKey} id={`ai-query-${query.queryKey}`}>
                <div className={styles.previouslyAskedQuestionAndAnswerTooltipWrapper}>
                    <div className={styles.previouslyAskedQuestionWrapper}>
                        Question:
                        <div className={styles.questionWrapper}>{question}</div>
                    </div>
                    <InformationTooltip content={answerValue} />
                </div>
            </div>
            <div className={styles.previouslyAskedQueryToggleWrapper}>
                <Toggle
                    onChange={() => toggleQuestion(query)}
                    checked={checked}
                />
            </div>
        </div>
    );
};
